import {ISoundsPlayer} from '@src/@interfaces/services/SoundsPlayer/ISoundsPlayer';
import {ISound} from '@src/@interfaces/services/SoundsPlayer/ISound';
import NotFoundException from '@src/exceptions/NotFoundException';
import Sound from '@src/services/SoundsPlayer/Sound';
import newOrderSound from '@client/assets/mp3/new-order-notification-sound.mp3';
import newOrderProductSound from '@client/assets/mp3/new-order-product-notification-sound.mp3';
import newOrderCommentSound from '@client/assets/mp3/new-order-or-order-product-comment-notificaiton-sound.mp3';
import newOrderProductCommentSound from '@client/assets/mp3/new-order-or-order-product-comment-notificaiton-sound.mp3';

const wellKnownSounds: Record<string, string> = {
    'new-order': newOrderSound,
    'new-order-product': newOrderProductSound,
    'new-order-comment': newOrderCommentSound,
    'new-order-product-comment': newOrderProductCommentSound,
} as const;

export default class SoundsPlayer implements ISoundsPlayer {
    protected wellKnownSounds = wellKnownSounds;
    protected soundsCache: Record<string, ISound> = {};

    getSound(soundName: string | keyof typeof wellKnownSounds): ISound {
        if (!this.hasSound(soundName)) {
            throw new NotFoundException(`Sound [${soundName}] not found`);
        }

        return this.soundsCache[soundName] ??= new Sound(this, soundName, this.wellKnownSounds[soundName]);
    }

    hasSound(soundName: string | keyof typeof wellKnownSounds): boolean {
        return soundName in wellKnownSounds;
    }

    preload(soundName: string | keyof typeof wellKnownSounds): Promise<void> {
        return this.getSound(soundName).preload();
    }

    isLoaded(soundName: string | keyof typeof wellKnownSounds): boolean {
        return this.getSound(soundName).isLoaded();
    }

    play(soundName: string | keyof typeof wellKnownSounds): Promise<void> {
        return this.getSound(soundName).play();
    }

    pause(soundName: string | keyof typeof wellKnownSounds): Promise<void> {
        return this.getSound(soundName).pause();
    }

    stop(soundName: string | keyof typeof wellKnownSounds): Promise<void> {
        return this.getSound(soundName).stop();
    }

    seek(soundName: string | keyof typeof wellKnownSounds, time: number): Promise<void> {
        return this.getSound(soundName).seek(time);
    }

    flushCache() {
        this.soundsCache = {};
    }
}
